export const PROFICIENCY_LEVELS = [
  { value: "POOR", label: "Poor", arabic_label: "ضعيف" },
  { value: "GOOD", label: "Good", arabic_label: "جيد" },
  { value: "FLUENT", label: "Fluent", arabic_label: "بطلاقة" },
];
